import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ChannelEntity } from '../../domain/entities/ChannelEntity'
import type { ChannelAdminDto } from '@/backend/market'
export class ChannelModel extends ChannelEntity {
  constructor(dataDto: ChannelAdminDto) {
    super()
    mapEntityProperties<ChannelModel>(this, dataDto, {
      map: {
        imageUrl: dataDto.profileImageUrl
      }
    })
  }
}
